import React from 'react';
import './index.css';
import { logoIcon, endCallIcon } from '../../assets';
import CallStore from '../../stores/CallStore';
import strings from '../../localization';
import Duration from '../Duration';
import VestelHeader from '../VestelHeader';

export const TechHeader = () => {

  const handleEndCall = () => {
    CallStore.setTechEndCallModal(true);
  }

  return (
    <VestelHeader>
      <div className="tech-header-right">
        <Duration />
        <button className="teach-call-container-bottom-end-call-btn button-cta-secondary button-cta-secondary-medium" onClick={handleEndCall}>
          <img src={endCallIcon} alt="white-phone" />
          <span>{strings.endCall}</span>
        </button>
      </div>
    </VestelHeader>
  );
};